import React, { useState } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { isValidSession } from "@/api/auth";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import { hasUserAcceptedForeClosureDocument, saveUserAcceptanceForeClosureDocument } from "@/api/PDP"
import { trackButtonClick } from "@/utils/analytics";

const DocumentSection = ({
  pdpDocuments,
  propertyDocumentsInformation,
  address,

}) => {

  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const user = useSelector((state) => state?.user);

  const dispatch = useDispatch();

  const { streetNumber, streetName, city, state, zip } = address;
  const fullAddress = `${streetNumber} ${streetName}, ${city}, ${state} ${zip}`;
  const { propertyDocumentMap, otherDocumentList } =
    propertyDocumentsInformation;

  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);


  const restrictDocumentDownloadFlag = pdpInitData?.restrictDocumentDownloadFlag;


  // const combinedDocuments = propertyDocumentMap.concat(otherDocumentList);



  const updatedPropertyDocumentMap = { ...propertyDocumentMap };

  otherDocumentList.forEach((doc, index) => {
    const key = `OTHER_DOC_${index + 1}`;
    updatedPropertyDocumentMap[key] = doc;
  });


  useEffect(() => {
    if (user) {

    }
  }, [user]);

  const hanldeOtherDocView = async (item) => {


    if (restrictDocumentDownloadFlag === 'Y') {
      const isSessionValid = await isValidSession();
      const isValid = isSessionValid.data?.isValidSession;


      if (isValid !== "Y") {
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
      } else {
        const hasUserAccepted = await hasUserAcceptedForeClosureDocument(pdpInitData?.propertyDetails?.propertyId);


        if (hasUserAccepted.data === "Y") {
          window.open(updatedPropertyDocumentMap[[item]]?.documentUrl?.indexOf(
            "https"
          ) > -1
            ? updatedPropertyDocumentMap[[item]]?.documentUrl
            : "https:" +
            updatedPropertyDocumentMap[[item]]?.documentUrl);
          // window.open(item.documentUrl?.indexOf("https") > -1
          //   ? item.documentUrl
          //   : "https:" + item.documentUrl);

        } else {
          setShowDisclaimer(true);
        }
      }
    } else {

      window.open(updatedPropertyDocumentMap[[item]]?.documentUrl?.indexOf(
        "https"
      ) > -1
        ? updatedPropertyDocumentMap[[item]]?.documentUrl
        : "https:" +
        updatedPropertyDocumentMap[[item]]?.documentUrl);
      // window.open(item.documentUrl?.indexOf("https") > -1
      //   ? item.documentUrl
      //   : "https:" + item.documentUrl);

    }

  }

  const hanldeDocView = async (item) => {
    trackButtonClick({
      eventName: "document_download",
      eventCategory: "NEW-PDP",
      eventSource: "on documents link click",
      eventLabel: `${
        item === "BCD"
          ? "Brokerage Commissions Document"
          : item === "ASSET_MANAGE_DOC"
          ? "Asset Management Document"
          : item === "FFL"
          ? "ALL US Protect Family From Lead"
          : item === "PSA"
          ? "Purchase & Sale Agreement"
          : item == "OTHER_DOC_1"
          ? "State-Specific Addendum"
          : item
      }`,
    });

    if (restrictDocumentDownloadFlag === 'Y') {
      const isSessionValid = await isValidSession();
      const isValid = isSessionValid.data?.isValidSession;


      if (isValid !== "Y") {
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
      } else {
        const hasUserAccepted = await hasUserAcceptedForeClosureDocument(pdpInitData?.propertyDetails?.propertyId);


        if (hasUserAccepted.data === "Y") {
          window.open(updatedPropertyDocumentMap[[item]]?.documentUrl?.indexOf(
            "https"
          ) > -1
            ? updatedPropertyDocumentMap[[item]]?.documentUrl
            : "https:" +
            updatedPropertyDocumentMap[[item]]?.documentUrl);

        } else {
          setShowDisclaimer(true);
        }
      }
    } else {
      window.open(updatedPropertyDocumentMap[[item]]?.documentUrl?.indexOf(
        "https"
      ) > -1
        ? updatedPropertyDocumentMap[[item]]?.documentUrl
        : "https:" +
        updatedPropertyDocumentMap[[item]]?.documentUrl);

    }

  }



  const handleClose = () => {
    setShowDisclaimer(false);
  }

  const hanldeIAgree = async () => {

    const saveUserAcceptance = await saveUserAcceptanceForeClosureDocument(pdpInitData?.propertyDetails?.propertyId);
    if (saveUserAcceptance.data === true) {
      setShowDisclaimer(false);

    }




  }


  return (

    // <><div className="documentGrid">
    //   {Object.keys(propertyDocumentMap).map((item, index) => {
    //     const doc = propertyDocumentMap[item];
    //     if (!doc?.documentUrl) return null;

    //     return (
    //       <div className="documentItem" key={index}>
    //         <h5>
    //           <a
    //             className="flaticon-pdf hubzu-text-thm pr10 documentText"
    //             style={{ textDecoration: "underline" }}
    //             target="_blank"
    //             onClick={(e) => {
    //               e.preventDefault();
    //               hanldeDocView(item);
    //             } }
    //           >
    //             {doc.documentName}
    //           </a>
    //         </h5>
    //       </div>
    //     );
    //   })}
    // </div><div className="documentGrid">
    //     {otherDocumentList.map((item, index) => (
    //       <div className="documentItem" key={index}>
    //         <h5>
    //           <a
    //             className="flaticon-pdf hubzu-text-thm pr10 documentText"
    //             style={{ textDecoration: "underline" }}
    //             target="_blank"
    //             onClick={(e) => {
    //               e.preventDefault();
    //               hanldeOtherDocView(item);
    //             } }
    //           >
    //             {item.documentName}
    //           </a>
    //         </h5>
    //       </div>
    //     ))}
    //   </div></>

    <div className="propertyInfoBox mb30 tour-pdp-details mobile-margin-0">
      <Row className="propertyInfoBoxHeading p0">
        <h3 className='propertyInfoBoxHeadingText' tabIndex="0" >
          Documents
        </h3>

      </Row>

      <div className="container px-0 px-sm-3">
        <div className="row">

          <div>
            <p className='disclaimerText pt25 pl20 pr25' tabIndex="0">{`${pdpDocuments?.description} ${fullAddress}`}</p>
            {/* </div> */}

            {/* Property Document Map Section */}
            <div className="documentGrid pb40 pt20">
              {Object.keys(updatedPropertyDocumentMap).map((item, index) => {
                const document = updatedPropertyDocumentMap[item];
                if (!document?.documentUrl) return null;

                return (
                  <div className="documentItem pt15" key={`property-${index}`}>
                    <a
                      className="flaticon-pdf hubzu-text-thm pr10 documentText"
                      style={{ textDecoration: "underline" }}
                      href={
                        document.documentUrl.startsWith("https")
                          ? document.documentUrl
                          : "https:" + document.documentUrl
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => {
                        e.preventDefault();
                        hanldeDocView(item);
                      }}
                    >
                      <span className="pl10"> { document.documentName}</span>

                    </a>
                  </div>
                );
              })}
            </div>

            {/* Other Document List Section */}
            {/* <div className="documentGrid pt20 pb20">
              {otherDocumentList?.length > 0 &&
                otherDocumentList.map((item, index) => {
                  if (!item?.documentName) return null;

                  return (
                    <div className="documentItem" key={`other-${index}`}>
                      <a
                        className="flaticon-pdf hubzu-text-thm pr10 documentText"
                        style={{ textDecoration: "underline" }}
                        href={
                          item.documentUrl?.startsWith("https")
                            ? item.documentUrl
                            : "https:" + item.documentUrl
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => {
                          e.preventDefault();
                          hanldeOtherDocView(item);
                        }}
                      >
                        {item.documentName}
                      </a>
                    </div>
                  );
                })}
            </div> */}

          </div>
        </div>
      </div>
      <div className="confirmationModel">
        <Modal show={showDisclaimer} onHide={handleClose}>
          <Modal.Header closeButton className="license-title pb0">
            <h4>Discalimer</h4>
          </Modal.Header>
          <Modal.Body className="">
            <p className="text-left pt20">
              By downloading any property-specific documents from Hubzu, I acknowledge that I have read, understood and accepted in-full the Disclaimers published on the property details page.

            </p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <button
              onClick={hanldeIAgree}
              className="btn hubzu-btn-thm rounded"
            >
              I Agree
            </button>

          </Modal.Footer>
        </Modal>
      </div>
    </div>

  );
};

export default DocumentSection;
